var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBtn)?_c('div',{staticClass:"back_btn",on:{"click":_vm.handleBack}},[_c('div',{staticClass:"back_btn_inner"},[_c('van-icon',{staticClass:"back_btn_icon",attrs:{"name":"arrow-left"}}),_c('span',{staticClass:"bank_btn_text"},[_vm._v(_vm._s(_vm.$t('global.back')))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }